module.exports = __webpack_public_path__ + "resources/img/img-zenius-apm-02-en.be3622640a58c5c5b4b48186432d5170.png";